/* EBH — «Avisa-me quando voltar» no cartão da grelha (2026-09-18)
   ---------------------------------------------------------------------------
   Um só guião para todos os cartões da página: os ouvintes são delegados no
   documento, e não um por cartão. Uma coleção tem 24 cartões e a paginação
   traz mais — um ouvinte por cartão era trabalho a multiplicar sem razão.

   A lista de «já pediu» é a MESMA da ficha de produto (ebh:bis:v1): quem pediu
   na ficha não volta a ver o botão na grelha, e ao contrário também.

   ⚠️ Cartões que nascem depois da página feita (vista rápida, recomendações,
      paginação) não disparam `shopify:section:load`. Quem os apanha é um
      MutationObserver agrupado com setTimeout — NUNCA com requestAnimationFrame:
      em separador escondido o rAF fica pendurado, a marca de «já pedi» não se
      limpa e o observador ensurdece para sempre.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (window.__ebhBisCartao) return;
  window.__ebhBisCartao = true;

  var PEDIDOS = 'ebh:bis:v1';
  var PROXY = '/apps/ebh/bis';

  function lista() {
    try { return JSON.parse(localStorage.getItem(PEDIDOS) || '[]') || []; }
    catch (e) { return []; }
  }
  function jaPediu(variante) {
    return lista().indexOf(String(variante)) !== -1;
  }
  function guardaPedido(variante) {
    try {
      var l = lista();
      if (l.indexOf(String(variante)) === -1) l.push(String(variante));
      localStorage.setItem(PEDIDOS, JSON.stringify(l.slice(-80)));
    } catch (e) {}
  }

  function caixaDe(alvo) {
    return alvo && alvo.closest ? alvo.closest('[data-bis-cartao]') : null;
  }

  /* A variante é a que o cartão MOSTRA. Com cores, o swatch activo manda — mas
     só o que troca de variante dentro deste produto: os que têm `data-ligacao`
     saltam para OUTRO produto e o seu id não tem nada a ver com este handle. */
  function variante(caixa) {
    var cartao = caixa.closest('.product-item') || caixa.parentElement;
    var activo = cartao && cartao.querySelector('[data-variant-id].is-active:not([data-ligacao])');
    var id = activo && activo.getAttribute('data-variant-id');
    return String(id || caixa.getAttribute('data-variante') || '');
  }

  function dizer(caixa, texto, erro) {
    var nota = caixa.querySelector('[data-bis-nota]');
    if (!nota) return;
    nota.textContent = texto || '';
    nota.hidden = !texto;
    nota.classList.toggle('is-erro', !!erro);
  }

  function mostraCaixa(caixa) {
    var campo = caixa.querySelector('.ebh-bisc__email');
    caixa.classList.add('is-aberta');
    var abrir = caixa.querySelector('[data-bis-abrir]');
    var form = caixa.querySelector('[data-bis-caixa]');
    var letras = caixa.querySelector('[data-bis-letras]');
    if (abrir) abrir.hidden = true;
    if (form) form.hidden = false;
    if (letras) letras.hidden = false;
    if (campo) campo.focus();
  }

  function marcaFeito(caixa, texto) {
    var abrir = caixa.querySelector('[data-bis-abrir]');
    var form = caixa.querySelector('[data-bis-caixa]');
    var letras = caixa.querySelector('[data-bis-letras]');
    if (abrir) abrir.hidden = true;
    if (form) form.hidden = true;
    if (letras) letras.hidden = true;
    caixa.classList.add('is-feita');
    dizer(caixa, texto, false);
  }

  /* Quem já pediu vê a confirmação em vez do botão. Corre no arranque e sempre
     que entram cartões novos no DOM. */
  function pintar(raiz) {
    var alvo = raiz && raiz.querySelectorAll ? raiz : document;
    var todas = [].slice.call(alvo.querySelectorAll('[data-bis-cartao]'));
    if (alvo !== document && alvo.matches && alvo.matches('[data-bis-cartao]')) todas.push(alvo);
    todas.forEach(function (caixa) {
      if (caixa.classList.contains('is-feita')) return;
      if (jaPediu(variante(caixa))) marcaFeito(caixa, caixa.getAttribute('data-ja-pediu') || '');
    });
  }

  function pedir(caixa) {
    var campo = caixa.querySelector('.ebh-bisc__email');
    var email = ((campo && campo.value) || '').trim();
    var v = variante(caixa);
    if (!email || email.indexOf('@') < 1 || !v) {
      dizer(caixa, caixa.getAttribute('data-erro') || '', true);
      return;
    }

    var btn = caixa.querySelector('[data-bis-enviar]');
    if (btn) btn.disabled = true;

    fetch(PROXY, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        email: email,
        variante: v,
        handle: caixa.getAttribute('data-handle') || '',
        url: caixa.getAttribute('data-url') || '',
        locale: (window.Shopify && Shopify.locale) || '',
        market: (window.Shopify && Shopify.country) || ''
      })
    }).then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) {
        if (btn) btn.disabled = false;
        if (d && d.ok) {
          guardaPedido(v);
          marcaFeito(caixa, caixa.getAttribute('data-feito') || '');
        } else {
          dizer(caixa, caixa.getAttribute('data-erro') || '', true);
        }
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        dizer(caixa, caixa.getAttribute('data-erro') || '', true);
      });
  }

  /* O cartão inteiro é uma zona de cliques do tema (vista rápida, ligação para
     a ficha). Tudo o que acontece aqui dentro fica aqui dentro. */
  document.addEventListener('click', function (ev) {
    var caixa = caixaDe(ev.target);
    if (!caixa) return;
    if (ev.target.closest('[data-bis-abrir]')) {
      ev.preventDefault();
      ev.stopPropagation();
      mostraCaixa(caixa);
      return;
    }
    if (ev.target.closest('[data-bis-enviar]')) {
      ev.preventDefault();
      ev.stopPropagation();
      pedir(caixa);
      return;
    }
    if (ev.target.closest('.ebh-bisc__email')) ev.stopPropagation();
  }, true);

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    var caixa = caixaDe(ev.target);
    if (!caixa || !ev.target.closest('.ebh-bisc__email')) return;
    ev.preventDefault();
    ev.stopPropagation();
    pedir(caixa);
  }, true);

  var pendente = null;
  function agenda() {
    if (pendente) return;
    pendente = setTimeout(function () { pendente = null; pintar(document); }, 60);
  }

  document.addEventListener('shopify:section:load', agenda);
  if (document.body) {
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        if (m[i].addedNodes && m[i].addedNodes.length) { agenda(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  pintar(document);
})();
